/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ImportExamItemBatchViewModel } from "../types/ImportExamItemBatchViewModel.ts";
import { importItemViewModelSchema } from "./importItemViewModelSchema.ts";

export const importExamItemBatchViewModelSchema = z.object({
  items: z
    .array(z.lazy(() => importItemViewModelSchema))
    .describe(
      "Lista de IDs das questões a serem importadas para provas dos idiomas (pt-BR, en-US ou/e es-ES) em lote.",
    )
    .nullish(),
}) as unknown as ToZod<ImportExamItemBatchViewModel>;
